// extracted by mini-css-extract-plugin
export var clauseRow = "_e2-6";
export var emptyState = "_e2-d";
export var filterContent = "_e2-a";
export var filterGroup = "_e2-1";
export var filterGroupContainer = "_e2-0";
export var nestedGroup = "_e2-2";
export var nestedGroupContent = "_e2-b";
export var nestedGroupDepth1 = "_e2-3";
export var nestedGroupDepth2 = "_e2-4";
export var nestedGroupDepth3 = "_e2-5";
export var nestedGroupEmpty = "_e2-c";
export var operatorAnd = "_e2-8";
export var operatorOr = "_e2-9";
export var operatorToggle = "_e2-7";
export var removeGroupButton = "_e2-e";